import { TableCell, TableRow } from '@material-ui/core'
import React from 'react'
import { toPrice } from '~/utils/format'
import Name from '../ui-kit/Name/Name'
import useStyles from './Meal.style'

/**
 * A subcomponent of Meal
 * @param {*} props
 */
const MealCustomization = (props) => {
  const classes = useStyles()

  const { customization } = props
  const totalPrice = customization.price * customization.quantity

  return (
    <TableRow>
      <TableCell
        align='left'
        size='small'
        className={classes.customizationsCell}
        data-locator='price'>
        {toPrice(totalPrice)}
      </TableCell>
      <TableCell className={classes.customizationsCell}>
        <Name name={customization.name} foreignName={customization.foreignName} />
        {customization.quantity > 1 && (
          <span data-locator='quantity'> x {customization.quantity}</span>
        )}
      </TableCell>
    </TableRow>
  )
}

export default MealCustomization
